export enum TaxPayerStatus {
    ACTIVE,
    SUSPENDED
  }  